<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="w-100" >
                <template #default>   <m-section-204 v-bind='{...{"image":"https:\/\/api.pamenarvillage.ir\/storage\/assets\/hero.png","sectionContainerMode":"container"},...{}}' :style='""' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto justify-content-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-12 text-center " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.pamenarvillage.ir\/storage\/products\/photo_2026-05-31_15-22-09.jpg","alt":"\u0631\u0648\u0633\u062a\u0627\u06cc \u06af\u0631\u062f\u0634\u06af\u0631\u06cc \u067e\u0627\u0645\u0646\u0627\u0631"},...{}}' :style='""' class="img-fluid col-6" ></m-img></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='""' class="text-dark d-inline-block  p-3  h4" >
                <template #default>Lake Boatmen's Cooperative   </template>
                </m-h1><m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>Lake boaters cooperative company was established with the purpose of order, creating solidarity, creating more employment for the village youth, proper use of lake boating income in creating public infrastructure, creating a suitable environment for the well-being of tourists, as well as more income for the residents of Pamnar and better distribution of the profits of lake water tourism.   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>CEO Reza Bahrami, contact number 09160699097   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>President Hossein Sasani, contact number 09167035239   </template>
                </m-p><m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>Vice President Ali Homaei, contact number 09920781030
Date of establishment: 9/2/1404   </template>
                </m-p></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="container mb-5" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto justify-content-center" >
                <template #default>   <m-form-single-1 v-bind='{...{"itemClass":"col-lg-12 mb-3","formId":2,"redirectToDashboard":false,"redirectDirectLink":""},...{}}' :style='""' class="bg-white py-5 rounded border shadow-sm  text-left" ></m-form-single-1></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-section-204></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="container mt-4" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row justify-content-between " >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/pamenarvillage.ir\/en\/blog?category=boat","target":"_self"},...{}}' :style='"font-size: 1.3rem"' class="text-dark" >
                <template #default>view all   </template>
                </m-a><m-h3 v-bind='{...{},...{}}' :style='"font-size: 1.3rem;"' class="" >
                <template #default>Boat news   </template>
                </m-h3><m-post-slider-900 v-bind='{...{"swiperPerViewSM":1,"swiperPerViewMD":3,"swiperPerViewLG":3,"postCard":"mPostCard915","cardLink":true,"contentCategories":["boat"]},...{}}' :style='""' class="col-12" ></m-post-slider-900></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mSection204 from '@moeinmdn/miw-alpha-components/src/package/Sections/Section204'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mFormSingle1 from '@moeinmdn/miw-alpha-components/src/package/Form/FormSingle/FormSingle1'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mH3 from '@moeinmdn/miw-alpha-components/src/package/Tags/H3'; import mPostSlider900 from '@moeinmdn/miw-alpha-components/src/package/Post/Slider/PostSlider900';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mSection204,mImg,mH1,mP,mFormSingle1,mA,mH3,mPostSlider900 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
